import * as React from 'react';
import { css } from 'aphrodite/no-important';
import { TypographySize } from 'mm-theme-configuration/dist/consts';
import { Link } from '../../../../partials/link/Link';
import { Span } from '../../../../../typography/semanticTags';
import { getLinksStyle } from './linkStyle.utils';
import { getStyleBySize } from '../../../../../typography/semanticTags/semanticTags.utils';
import { useTheme } from '../../../../../theming/useTheme';

interface RegularHeaderLinkProps {
  activeStateColor: string;
  hoverStateColor: string;
  idleColor: string;
  isActive: boolean;
  href: string;
  text: string;
  linkFontSizeLarge: TypographySize;
  linkFontSizeMedium: TypographySize;
  linkFontSizeSmall: TypographySize;
}

export const RegularHeaderLink: React.FunctionComponent<RegularHeaderLinkProps> = props => {
  const { href, text, activeStateColor, hoverStateColor, idleColor, isActive, linkFontSizeLarge, linkFontSizeMedium, linkFontSizeSmall } = props;
  const { fontSizesStyles } = useTheme();
  const style = getLinksStyle(activeStateColor, hoverStateColor, idleColor, isActive);
  const fontStyle = getStyleBySize(fontSizesStyles, { fontSizeSmall: linkFontSizeSmall, fontSizeMedium: linkFontSizeMedium, fontSizeLarge: linkFontSizeLarge });

  return (
    <Link href={href} className={css(style.link)}>
      <Span className={css(fontStyle)}>{text}</Span>
    </Link>
  );
};
